<template>
  <img :src="process_src" :width="process_width" :height="process_height" />
</template>

<script>
/* eslint-disable */
export default {
  name: "MyImage",
  props: ["src", "width", "height"],
  data() {
    return {
      process_src: "/static/images/no-photo.jpg",
      process_width: "auto",
      process_height: "auto"
    };
  },

  mounted() {
    this.process_src = this.src ? this.src : this.process_src;
    this.process_width = this.width ? this.width : this.process_width;
    this.process_height = this.height ? this.height : this.process_height;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/elements/MyImage.vue